var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[_vm._l((_vm.componentList),function(item,index){return _c('HomeComponents',{key:index,attrs:{"item":item}})}),_c('div',{staticStyle:{"height":"12px"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }